import React, { useState } from 'react';
import './Experience.css';

const Experience = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const experiences = [
    {
      role: 'Help Desk Technician',
      company: 'National Steel Car Ltd',
      location: 'Hamilton, ON',
      duration: 'February, 2026 – Present',
      responsibilities: [
        'Provided Tier 1–2 technical support by diagnosing and resolving hardware, software, and network issues for office and production staff, ensuring minimal downtime.',
        'Managed Active Directory user accounts, password resets, and system access, while configuring and deploying Windows workstations and peripherals.',
        'Resolved and tracked IT issues through a ticketing system, delivering timely support and clear communication to non-technical users.',
        ' Troubleshot network configuration issues involving DHCP, DNS, and IP addressing, restoring connectivity for users and maintaining reliable network access.'
      ]
    },
    {
      role: 'Software Developer',
      company: 'Mediserve Pharmacy',
      location: 'Hamilton, ON',
      duration: 'January, 2026 – Present',
      responsibilities: [
        'Developed internal web tools (Node.js, JavaScript, MongoDB) to organize and surface pharmacy data for daily operations',
        'Automated manual tracking workflows, reducing data lookup time and improving operational visibility',
        'Collaborated directly with pharmacy staff to gather requirements and deliver practical, production-ready tools',
        'Deployed and maintained applications on AWS EC2; provided ongoing technical support and system improvements'
      ]
    },
    {
      role: 'Tennis Instructor',
      company: 'Rosedale Tennis Club',
      location: 'Hamilton, ON',
      duration: 'May – September, 2021 – 2023',
      responsibilities: [
        'Taught students across all ages and skill levels; fostered an inclusive, encouraging environment',
        'Planned and facilitated day camps, adult leagues and private lessons end-to-end',
        'Developed teamwork, clear communication, and collaboration skills'
      ]
    },
    {
      role: 'Pharmacy Assistant',
      company: 'Mediserve Pharmacy',
      location: 'Hamilton, ON',
      duration: 'June – September, 2020',
      responsibilities: [
        'Managed customer service, inventory, administrative tasks, and prescription handling',
        'Ensured high accuracy and attention to detail during data entry and workflow processes',
        'Applied efficient time-management to balance customer support, task loads and operational demands'
      ]
    }
  ];

  const toggleCard = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
      <div className="experience-container" id="experience">
        <h1 className="experience-title">Work Experience</h1>

        {experiences.map((exp, index) => {
  const isExpanded = expandedIndex === index;
  return (
    <div
      key={index}
      className={`experience-card ${isExpanded ? 'expanded' : ''}`}
      onClick={() => !isExpanded && toggleCard(index)}
    >
      <div className="experience-header">
        <h2>{exp.role} <span>– {exp.company}</span></h2>
        <p className="experience-location">{exp.location} | {exp.duration}</p>

        {/* Show hint only when not expanded */}
        {!isExpanded && (
          <p className="expand-hint">Click to expand</p>
        )}

        {isExpanded && (
          <button
            className="close-button"
            onClick={(e) => {
              e.stopPropagation();
              toggleCard(index);
            }}
          >
            ×
          </button>
        )}
      </div>

      {isExpanded && (
        <ul className="experience-details">
          {exp.responsibilities.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
})}

      </div>
  );
};

export default Experience;

